/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MoonFilled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.9992 17.145C21.5424 16.2645 20.6694 15.283 19.6348 15.283C14.2938 15.283 9.9641 10.7721 9.9641 5.20762C9.9641 3.72468 8.7022 2.35332 7.39183 3.04762C4.18181 4.74843 2 8.08579 2 11.9246C2 17.4891 6.58441 22 12.2396 22C15.9525 22 19.2039 20.0555 20.9992 17.145Z"
                        fill={color}
                    />
                </svg>
        );
    };
